import React, { useMemo } from "react";
import clsx from "clsx";

import {
  getStudentAnswersByQuestion,
  getLessonFrom,
  getIssueFrom,
} from "../../../../libs/ActiveLearning";
import {
  IActiveLearningMaterialLessonsData,
  IActiveLearningStudentAnswers,
  IActiveLearningAllAnswers,
} from "../../../../state";
import TreeCard from "../../../../atoms/ActiveLearning/TreeCard";
import styles from "../LessonsAnswerData.module.scss";

type Lesson8Pros = {
  materialCode: string;
  lessonNo: number;
  activeLearningMaterialLessons: IActiveLearningMaterialLessonsData[];
  activeLearningAnswers:
    | IActiveLearningStudentAnswers
    | IActiveLearningAllAnswers
    | null;
};

export const Lesson8: React.FC<Lesson8Pros> = ({
  materialCode,
  lessonNo,
  activeLearningMaterialLessons,
  activeLearningAnswers,
}) => {
  const activeLearningMaterialLessonsByCode = useMemo(() => {
    return activeLearningMaterialLessons.filter(
      data => data.code === materialCode,
    );
  }, [activeLearningMaterialLessons, materialCode]);

  const titleL8 = useMemo(() => {
    return getLessonFrom(activeLearningMaterialLessonsByCode, lessonNo)?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const titleL8I1 = useMemo(() => {
    return getIssueFrom(activeLearningMaterialLessonsByCode, lessonNo, 1)
      ?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const titleL8I2 = useMemo(() => {
    return getIssueFrom(activeLearningMaterialLessonsByCode, lessonNo, 2)
      ?.title;
  }, [activeLearningMaterialLessonsByCode, lessonNo]);

  const answersL8I1Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      lessonNo,
      1,
      1,
    );
  }, [materialCode, activeLearningAnswers, lessonNo]);

  const answersL5I2Q6 = useMemo(() => {
    const answers = getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      materialCode === "ECS001" ? 5 : 6,
      2,
      6,
    );

    return answers.length > 0
      ? answers.map(answer => answer.contents.value).join("")
      : "回答データがありません。";
  }, [materialCode, activeLearningAnswers]);

  const answersL8I2Q1 = useMemo(() => {
    return getStudentAnswersByQuestion(
      materialCode,
      activeLearningAnswers,
      lessonNo,
      2,
      1,
    );
  }, [materialCode, activeLearningAnswers, lessonNo]);

  return (
    <div className={styles.lesson}>
      <p className={styles.title}>
        Lesson{lessonNo < 10 ? `0${lessonNo}` : lessonNo} {titleL8}
      </p>
      <div className={styles.inner}>
        <div className={styles.work}>
          <p className={styles.no}>WORK01</p>
          <div className={styles.question}>
            <p className={styles.heading}>{titleL8I1}</p>
            <div className={styles.multiple}>
              <div className={styles.block}>
                <p className={styles.label}>わかったこと</p>
                {answersL8I1Q1.length > 0 ? (
                  answersL8I1Q1.map(answer => (
                    <p
                      key={answer.id}
                      className={clsx(styles.answer, styles.high)}
                    >
                      {answer.contents.good}
                    </p>
                  ))
                ) : (
                  <p className={clsx(styles.answer, styles.high)}>
                    回答データがありません。
                  </p>
                )}
              </div>
              <div className={styles.block}>
                <p className={styles.label}>改善点</p>
                {answersL8I1Q1.length > 0 ? (
                  answersL8I1Q1.map(answer => (
                    <p
                      key={answer.id}
                      className={clsx(styles.answer, styles.high)}
                    >
                      {answer.contents.motto}
                    </p>
                  ))
                ) : (
                  <p className={clsx(styles.answer, styles.high)}>
                    回答データがありません。
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className={styles.work}>
          <p className={styles.no}>WORK02</p>
          <div className={styles.question}>
            <p className={styles.heading}>{titleL8I2}</p>
            <div className={styles.tree}>
              <TreeCard title={"解決のアイデア"} text={answersL5I2Q6} />
              <ul className={styles.branchList}>
                {answersL8I2Q1.length > 0 ? (
                  answersL8I2Q1.reverse().map(answer => (
                    <li key={answer.id} className={styles.branch}>
                      <div className={styles.labelWrapper}>
                        <span className={styles.label}>
                          ステップ{answer.contents.stepNo}
                        </span>
                      </div>
                      <p className={styles.answer}>{answer.contents.value}</p>
                    </li>
                  ))
                ) : (
                  <li className={styles.branch}>
                    <div className={styles.labelWrapper}>
                      <span className={styles.label}>ステップ</span>
                    </div>
                    <p className={styles.answer}>回答データがありません。</p>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lesson8;
